module.exports = __webpack_public_path__ + "static/media/video-call2.214f22a1.svg";